import axios from 'axios';
import * as types from '../mutation-types';

export default {
  state: {
    all: [],
  },
  getters: {
    getClues: state => state.all,
    getCluesForLevel: state => _level => state.all.filter(({ level }) => level <= _level),
  },
  actions: {
    getClues({ commit }) {
      return new Promise((resolve) => {
        axios.get('https://acl.new.pixel-kraft.de/api/clues').then(({ data: { data } }) => {
          commit(types.RECEIVED_CLUES, { data });
          resolve(data);
        });
      });
    },
  },
  mutations: {
    [types.RECEIVED_CLUES](state, { data }) {
      state.all = data;
    },
    [types.CLEARED_CLUES](state) {
      state.all = [];
    },
  },
};
